"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboboxOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Highlighter = require("../Highlighter/Highlighter");
var _ComboboxOption = require("./ComboboxOption.styles");
var _excluded = ["highlightPattern", "label"];
/**
 * @since 8.28.0
 */
var ComboboxOption = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var highlightPattern = _ref.highlightPattern,
    label = _ref.label,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var labelNode = label;
  if (label && highlightPattern) {
    labelNode = /*#__PURE__*/_react.default.createElement(_Highlighter.Highlighter, {
      text: label,
      pattern: highlightPattern
    });
  }
  return /*#__PURE__*/_react.default.createElement(_ComboboxOption.StyledComboboxOption, (0, _extends2.default)({
    ref: forwardedRef,
    label: labelNode
  }, rest));
});
exports.ComboboxOption = ComboboxOption;
ComboboxOption.displayName = 'ComboboxOption';
ComboboxOption.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Highlight the matched part of an option `label`.
   *
   * See `Highlighter` for more info.
   */
  highlightPattern: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(RegExp)]),
  /**
   * The label to display for this option.
   */
  label: _propTypes.default.string
} : {};